import { ComponentInProjectAttribute } from '@aedifion.io/aedifion-api'

export const getAttrbiuteValueByAlphanumericId = (attributes: ComponentInProjectAttribute[], alphanumeric_id: string): string|null => {
  const attribute: ComponentInProjectAttribute|undefined = attributes.find((attribute: ComponentInProjectAttribute) => attribute.alphanumeric_id === alphanumeric_id || attribute.alphanumeric_id!.includes(alphanumeric_id))
  if (!!attribute && !!attribute.value) return attribute.value
  return null
}
